import type { ButtonProps } from "@mui/material";
import { AppButton } from "../../../../../shared/components/AppButton";
import styles from "../../styles.module.css";

interface Props extends ButtonProps {
  btnText: string;
  onSubmit: () => void;
}

export const SubmitButton = ({ onSubmit, btnText, ...rest }: Props) => {
  return (
    <div className={styles["button-container"]}>
      <AppButton
        onClick={onSubmit}
        className={styles["login-button"]}
        buttonType="contained"
        type={"button"}
        {...rest}
      >
        {btnText}
      </AppButton>
    </div>
  );
};
